import './bootstrap';
import Vue from 'vue';
import App from './App.vue';
import router from './router.js';
import store from './store.js';
import Loading from 'vue-loading-overlay';
import VueTinyLazyloadImg from 'vue-tiny-lazyload-img';
import './mixin.js';
import moment from 'moment';
moment.locale('id');
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { Datetime } from 'vue-datetime';
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css';
import { Settings } from 'luxon';
Settings.defaultLocale = 'id';

import './registerServiceWorker';
import './assets/sass/style.scss';
import 'vue-loading-overlay/dist/vue-loading.css';

// Component ==========================================
Vue.component('Toast', require('./components/Toast.vue').default);
Vue.component('ButtonLoader', require('./components/ButtonLoader.vue').default);
Vue.component('loading-app', require('./components/LoadingApp.vue').default);
Vue.component('action-sheet', require('./components/ActionSheet.vue').default);
Vue.component(
    'action-sheet-sender',
    require('./components/ActionSheetSender.vue').default
);
Vue.component('Dialog', require('./components/Dialog.vue').default);
Vue.component('Modal', require('./components/Modal.vue').default);
Vue.component('Loading', Loading);
Vue.component(
    'privacy-policy',
    require('./components/PrivacyPolicy.vue').default
);
Vue.component(
    'term-of-service',
    require('./components/TermOfService.vue').default
);
Vue.component('qr-code', require('./components/QRCode.vue').default);
Vue.component('datetime', Datetime);

// Filter ==========================================
Vue.filter('rupiah', function (value) {
    var val = parseInt(value);
    return val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
});

Vue.filter('date', function (date) {
    return moment(date).format('D MMMM YYYY');
});

Vue.filter('time', function (date) {
    return moment(date).format('HH:mm:ss');
});

// Vue.use(Datetime);
Vue.use(VueTinyLazyloadImg);
Vue.config.productionTip = false;
Vue.config.ignoredElements = [/^ion-/];

window.Pusher = Pusher;

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.VUE_APP_PUSHER_APP_KEY,
    cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
    wsHost: process.env.VUE_APP_PUSHER_APP_HOST,
    wsPort: process.env.VUE_APP_PUSHER_APP_PORT,
    forceTLS: false,
    disabledStats: true,
    enabledTransports: ['ws', 'wss'],
    authEndpoint: process.env.VUE_APP_BROADCASTING_URL + '/broadcasting/auth',
    auth: {
        headers: {
            Authorization: `Bearer ${store.state.token}`,
        },
    },
});

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
